export default __webpack_public_path__ + "static/media/hands.b408e771.png";